import Request from "@/common/net/request.js";
const request = new Request();
// 获取列表
export function getPage(data) {
  return request.send({
    url: `/pmy/sys/external-app/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 添加
export function addInfo(data) {
  return request.send({
    url: `/pmy/sys/external-app`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 编辑
export function editInfo(data) {
  return request.send({
    url: `/pmy/sys/external-app`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}

// 删除
export function deleteInfo(appId) {
  return request.send({
    url: `/pmy/sys/external-app?appId=${appId}`,
    method: "delete",
  });
}
// 启用 警用
export function externalAppStatus(data) {
  return request.send({
    url: `/pmy/sys/external-app/status`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
// 详情
export function detailInfo(appId) {
  return request.send({
    url: `/pmy/sys/external-app/info?appId=${appId}`,
    method: "get",
  });
}

// 重置秘钥
export function resetSecret(data) {
  return request.send({
    url: `/pmy/sys/external-app/reset-secret`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json",
      },
    },
  });
}
